"use strict";
import axios from "axios";
import GBLVAR from "../Global Variables/GlobalVariables";
import cookie from "react-cookies";

class ApiCall {
   returnCurrentCountry() {
    return axios.get(GBLVAR.GET_COUNTRY)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
  }
  constructor() {}

  get(url, callback) {
    this.callApiRequest(url, null, 0,callback);
  }

  post(url, data, callback,header) {
    console.log("header",header)
    this.callApiRequest(url, data, 1,callback);
  }

  patch(url, data, callback) {
    this.callApiRequest(url, data, 2,callback);
  }

  delete(url, data, callback) {
    this.callApiRequest(url, data, 3,callback);
  }

  callApiRequest(append, data, type, callback) {
    var instance = axios.create();
    instance.defaults.headers.post["Content-Type"] = "application/json";
    instance.defaults.headers.common["auth_token"] = cookie.load("auth_token");
    instance.defaults.headers.common["Authorization"] = `Bearer ${cookie.load("authentication")}`;
    instance.defaults.headers.common["X-Consumer-Custom-ID"] = cookie.load("customer_id");
    instance.defaults.headers.common["platform"] = "web";
    
    var url;
    url = append;
    var task;
    switch (type) {
      case 0:
        task = instance.get(url);
        break;
      case 1:
        task = instance.post(url, data);
        break;
      case 2:
        task = instance.patch(url, data);
        break;
      default:
        task = instance.delete(url, data);
        break;
    }

    task
      .then(result => {
        callback(result.data);
      })
      .catch(error => {
        if (error && error.response) {
          console.log("error.response",error.response)
          console.log("error.response.data",error.response.status)
          if(error.response.status == 401){
            window.location.href = '/';
          } else {
            callback({message :  error.response.data.message});
          }
          //else if (error.response.status === 422){
          //   callback(error.response.data.error);
          // } else {
          //   //window.location.href = '/';
          // }
        }
      });
  }
}

export default new ApiCall();